<template>
  <div class="organization">
    <el-form :inline="true" :model="queryDataQuery.limit" size="mini" label-width="85px" ref="formInlineres">
      <el-form-item>
        <el-input prefix-icon="el-icon-search" v-model="queryDataQuery.limit.keyword" placeholder="请输入要搜索的内容" clearable> </el-input>
      </el-form-item>
      <el-form-item label="医院类型：">
        <el-select v-model="queryDataQuery.limit.orgType" placeholder="请选择" clearable>
          <el-option :label="sub.name" :value="sub.id" v-for="(sub, subIndex) in orgTypeList" :key="subIndex"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="业务分类：">
        <el-select v-model="queryDataQuery.limit.businessType" placeholder="请选择" clearable>
          <el-option :label="sub.name" :value="sub.id" v-for="(sub, subIndex) in businessTypeList" :key="subIndex"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="医院等级：">
        <el-select v-model="queryDataQuery.limit.level" placeholder="请选择" clearable>
          <el-option :label="sub.name" :value="sub.id" v-for="(sub, subIndex) in departmentList" :key="subIndex"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="修改时间：">
        <el-date-picker v-model="queryDataQuery.limit.time" type="daterange" value-format="yyyy-MM-dd HH:mm:ss" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"> </el-date-picker>
      </el-form-item>
      <!-- <el-form-item>
        <el-row type="flex" justify="end">
          <el-button type="primary" size="mini" @click="resetHandel">重置</el-button>
          <el-button type="primary" size="mini" @click="queryHandel">搜索</el-button>
          <el-button type="primary" size="mini" @click="addHandel">新增</el-button>
        </el-row>
      </el-form-item> -->
    </el-form>

     <el-form inline>
      <el-form-item label="状态筛选：">
        <el-tabs
          v-model="queryDataQuery.limit.disabled"
          type="card"
        >
          <el-tab-pane
            :label="item.label"
            :name="item.label"
            v-for="(item, index) in tabList"
            :key="index"
          ></el-tab-pane>
        </el-tabs>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="mini" @click="resetHandel"
          >重置</el-button
        >
        <el-button type="primary" size="mini" @click="queryHandel"
          >搜索</el-button
        >
        <el-button type="primary" size="mini" @click="addHandel"
          >新增</el-button
        >
      </el-form-item>
    </el-form>
 
    <!-- 表格 -->
    <BaseTable
        size="mini"
        border
        stripe
        :data="all"
        :column="homeColumnConfig"
        pagination
        :auto-scroll="true"
        :total="queryDataQuery.total"
        :page.sync="queryDataQuery.limit.current"
        :limit.sync="queryDataQuery.limit.size"
        @selection-change="homeChangeTab"
        @pagination="homeChangeTabHandel"
        >
        </BaseTable>
     <el-dialog
      :visible.sync="centerDialogVisible"
      :width="width"
      center
      :fullscreen="false"
      modal
      :close-on-click-modal="false"
      :show-close="true"
      :destroy-on-close="true"
      :top="top"
      custom-class="customWidth"
      @close="dialogClose"
    >
      <slot name="title" class="dialog-footer">
        <div class="slot-footer">
          <h1 class="title">基本信息</h1>
          <el-button
            type="text"
            size="mini"
            class="btn"
            @click="edit = !edit"
            v-if="!isNewAdd"
            >{{ edit ? "编辑" : "只读" }}</el-button
          >
        </div>
      </slot>

      <div :style="{ height: `${height}` }">
        <el-scrollbar style="height: 100%" wrap-style="overflow-x:hidden;" >
          <el-form
            inline
            size="mini"
            label-width="120px"
            ref="fromDatas"
            :rules="addFormRules"
            :model="fromData" 
          >
            <el-form-item label="机构名称：" prop="name">
              <el-input :disabled="edit" v-model="fromData.name"></el-input>
            </el-form-item>
            <el-form-item label="医院简称：" prop="shortName">
              <el-input
                :disabled="edit"
                v-model="fromData.shortName"
              ></el-input>
            </el-form-item>
            <el-form-item label="可用状态：">
              <el-radio-group :disabled="edit" v-model="fromData.disabled">
                <el-radio :label="false">启用</el-radio>
                <el-radio :label="true">禁用</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="医院类型：" prop="orgType">
              <el-select
                v-model="fromData.orgType"
                placeholder="请选择"
                clearable
                :disabled="edit"
              >
                <el-option
                  :label="sub.name"
                  :value="sub.id"
                  v-for="(sub, subIndex) in orgTypeList"
                  :key="subIndex"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="医院等级：" prop="level">
              <el-select
                v-model="fromData.level"
				@change="fromData.grade=''"
                placeholder="请选择"
                clearable
                style="width: 100px;margin-right: 10px;"
                :disabled="edit"
              >
                <el-option
                  :label="sub.name"
                  :value="sub.id"
                  v-for="(sub, subIndex) in departmentList"
                  :key="subIndex"
                ></el-option>
              </el-select>
              <el-select
                v-model="fromData.grade"
                placeholder="请选择"
                clearable
                style="width: 100px;"
                :disabled="edit"
              >
                <el-option
                  :label="sub.name"
                  :value="sub.id"
                  v-for="(sub, subIndex) in departmentList1"
                  :key="subIndex"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="业务分类：" prop="businessType">
              <el-select
                v-model="fromData.businessType"
                placeholder="请输入"
                clearable
                :disabled="edit"
				filterable
              >
                <el-option
                  :label="sub.name"
                  :value="sub.id"
                  v-for="(sub, subIndex) in businessTypeList"
                  :key="subIndex"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="所属区域：" prop="cityList">
              <el-cascader
                placeholder="选择或者搜索"
                v-model="fromData.cityList"
                :props="setKesDept"
                :options="options"
                :disabled="edit"
                filterable
                clearable
              >
              </el-cascader>
            </el-form-item>
            <el-form-item label="机构地址：" prop="address">
              <el-input
              type="textarea"
              resize="none"
              autosize
               :disabled="edit" v-model="fromData.address"></el-input>
            </el-form-item>
            <el-form-item label="医院简介：" prop="description">
              <el-input
                :disabled="edit"
                type="textarea"
              resize="none"
                v-model="fromData.description"
              ></el-input>
            </el-form-item>
            <el-form-item label="经度：" prop="longitude">
              <el-input
                :disabled="edit"
                autosize
                type="number"
              resize="none"
                v-model="fromData.longitude"
              ></el-input>
            </el-form-item>
            <el-form-item label="纬度：" prop="latitude">
              <el-input
                :disabled="edit"
                autosize
                type="number"
              resize="none"
                v-model="fromData.latitude"
              ></el-input>
            </el-form-item>
          </el-form>
          <!-- 图片上传 -->
          <el-form inline size="mini" label-width="110px"  >
            <el-form-item label="配图：">
            <el-image 
                style="width: 100px; height: 100px"
                :src="imageUrl" 
                :preview-src-list="[imageUrl]"
                :z-index="20001"
                v-if="edit"
                >
            </el-image>

              <BaseUploadFile
              v-if="!edit"
                v-model="fromData.imageUrl"
                :fileSize="6"
                :isShowTip="false"
                :size="100"
                :responseFn="handleBackgroundResponse"
                action="/api/dsicm-contact-platform/feign/file/upload"
                :data="{ path: 'dsicm-doctor' }"
              >
              </BaseUploadFile>
            </el-form-item>
          </el-form>
          <!-- 创建人更新时间 -->
            
          <div class="footer" v-if="!isNewAdd">
            <p>
              <span>创建人:</span>
              <span>{{scopeItem.createUserId}}</span>
            </p>
            <p>
              <span>创建时间:</span>
              <span>{{scopeItem.createTime}}</span>
            </p>
            <p>
              <span>最后更新:</span>
              <span>{{scopeItem.updateUserId}}</span>
            </p>
            <p>
              <span>更新时间:</span>
              <span>{{scopeItem.updateTime}}</span>
            </p>
          </div>
        </el-scrollbar>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="commit"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { api_hospital, codechildren ,addhospital,puthospital} from '@/api/org.js'
import { regionAll , hospitalDisable, hospitalEnable,hospital_new_level} from "./api";

import TableConfig from './conmon/organizationCongig'
export default {
  mixins: [TableConfig],
  data() {
    return {
            tabList: [
        //el-tab-pane
        {
          label: "全部",
          name: "",
        },
        {
          label: "启用",
          name: 0,
        },
        {
          label: "停用",
          name: 1,
        },
      ],
      orgTypeList: [], //医院类型
      businessTypeList: [], //业务分类
      departmentList: [], //医院等级
	  departmentList1:[],
      formInline: {
        name: '', //文本输入
        orgType: '', //医院类型
        businessType: '', //业务类型
        level: '', //医院等级
		grade:'',
        time: [],
      },
      queryDataQuery: {
        total: 0,
        limit: {
          current: 1,
          disabled:'全部',
          size: 10,
          keyword: '', //文本输入
          orgType: '', //医院类型
          businessType: '', //业务类型
          level: '', //医院等级
          time: [],
          updateEndTime: '', //修改结束时间
          updateStartTime: '', //修改开始时间
        },
      },
      input: '', //搜索组件
      value1: '', //选择日期组件
      activeName: 'first', //内容页面选项卡默认选中页面
      all: [], //全部表单数据
      drawer: false, //弹出框
      direction: 'rtl', //弹出框
      statusFormatter: '',


      edit: true, //是否可以修改
      isNewAdd: true, //是否新增 默认为新增，新增不展示修改按钮，详情才展示
      options: [], //省市区数据
      setKesDept: {
        value: "id",
        label: "name",
      },
      title: "基本信息",
      width: "80%",
      top: "5vh",
      height: "50vh",
      fromData: {
        name: "", //机构名称
        shortName: "", //医院简称
        disabled: false, //可用状态 1禁用 0 启用
        orgType: "", //  医院类型
        level: "", //医院等级
		grade:'',
        businessType: "", //业务分类
        // hospitalId: "", //依托实体医院
        address: "", //机构地址
        description: "", //医院简称
        imageUrl: "", //配图url
        cityList: "", //所属医院
        longitude:"",
        latitude:'',
      },
      centerDialogVisible:false,
      imageUrl:'',
      scopeItem:'',

    }
  },
  methods: {

    homeChangeTab(){

    },
    homeChangeTabHandel(){
      this.init()
    },

    /**
     * @description: 查看详情
     * @param {*}
     * @return {*}
     */  
    hometHandelDetails(scope){
        this.scopeItem = scope.row;
        this.imageUrl = `${process.env.VUE_APP_OSS_URL}`+scope.row.imageUrl
        this.centerDialogVisible = !this.centerDialogVisible
        this.isNewAdd = false;
        this.edit = true;
        //关键字 hasOwnProperty 
        Object.keys(this.fromData).forEach(item=>{
            if(scope.row.hasOwnProperty(item)){
                if(item == 'imageUrl'){
                    this.fromData[item] = `${process.env.VUE_APP_OSS_URL}`+scope.row[item]
                }else{
                    this.fromData[item] = scope.row[item]
                }
            }else{
                this.fromData[item] = [
                  `${scope.row.province}`,
                  `${scope.row.city}`,
                  `${scope.row.district}`
                ]
            }
        })
    },

    /**
     * @description: 禁用启用
     * @param {*}
     * @return {*}
     */
    disableHandel(scope){
      const scopeItem = scope.row;
      if(scopeItem.disabled){//调用启用
      hospitalEnable(scopeItem.id).then(res=>{
        if(res.code == 0){
          scope.row.disabled = !scope.row.disabled;
          this.all.splice(scope.$index,1,scope.row)
        }
      })
      }else{//调用禁用
        hospitalDisable(scopeItem.id).then(res=>{
          if(res.code  == 0 ){
            scope.row.disabled = !scope.row.disabled;
            this.all.splice(scope.$index,1,scope.row)
          }
        })
      }
    },
    /**
     * @description: 获取省市区
     * @param {*}
     * @return {*}
     */
    regionAll() {
      regionAll().then((res) => {
        if (res.code == 0) {
          this.options = res.data;
        }
      });
    },

     /**
     * @description: 新增或者修改
     * @param {*}
     * @return {*}
     */
    commit(){
      this.$refs["fromDatas"].validate(async (valid) => {
        if (valid) {
			if (!this.fromData.grade) return this.$message({ type:'error', message:'请选择医院等级' })
          if (!this.fromData.imageUrl) return this.$message({ type:'error', message:'请上传配图' })
            let paramData = JSON.parse(JSON.stringify(this.fromData));
            paramData.imageUrl = paramData.imageUrl.substring(process.env.VUE_APP_OSS_URL.length)
            let cityObj = {
                province:paramData.cityList[0],
                city:paramData.cityList[1],
                district:paramData.cityList[2]
            }
            paramData = Object.assign({},paramData,cityObj)
            if(this.isNewAdd){
               
                //新增
                addhospital(paramData).then(res=>{
                    if(res.code == 0){
                        this.$message({
                            type:'success',
                            message:'添加成功'
                        })
                        this.fromData = this.$options.data().fromData;
                        this.centerDialogVisible = false
                        this.init()
                    }
                })
            }else{
              //修改
              paramData.id = this.scopeItem.id
              puthospital(paramData).then(res=>{
                if(res.code == 0){
                    this.$message({
                        type:'success',
                        message:'修改成功'
                    })
                    this.fromData = this.$options.data().fromData;
                    this.centerDialogVisible = false
                    this.init()
                }
              })
            }
        } else {
          return false;
        }
      });
    },
    /**
     * @description: 图片上传
     * @param {*}
     * @return {*}
     */
    handleBackgroundResponse(response){
      if (response.code == 0) {
        return this.fromData.imageUrl = `${process.env.VUE_APP_OSS_URL}`+response.data
      }
    },
      /**
     * @description: 关闭diaolog弹窗，需要把数据给清空
     * @param {*}
     * @return {*}
     */
    dialogClose(){
      this.fromData = this.$options.data().fromData
    },
    /**
     * @description: 新增医院信息
     * @param {*}
     * @return {*}
     */
    addHandel() {
      this.isNewAdd = true;
      this.edit = false;
      this.centerDialogVisible = !this.centerDialogVisible
    },
    /**
     * @description:
     * @event:
     * @param {*}
     * @return {*}
     */
    getcodechildrenList() {
      // 医院等级
      codechildren('hospital_new_level').then((res) => {
        if (res.code == 0) {
          this.departmentList = res.data
        }
      })
	  codechildren('hospital_grade').then((res) => {
	    if (res.code == 0) {
	      this.departmentList1 = res.data
	    }
	  })
      // 医院业务类型
      codechildren('hospital_business_type').then((res) => {
        if (res.code == 0) {
          this.businessTypeList = res.data
        }
      })
      // 医院组织类型
      codechildren('hospital_org_type').then((res) => {
        if (res.code == 0) {
          this.orgTypeList = res.data
        }
      })
    },
    /**
     * @description:
     * @event:
     * @param {*}
     * @return {*}
     */
    resetHandel() {
      let data = {
        current:1,
        size:10,
        keyword: '', //文本输入
        disabled:'全部',
        orgType: '', //医院类型
        businessType: '', //业务类型
        level: '', //医院等级
        time: [],
        updateEndTime: '', //修改结束时间
        updateStartTime: '', //修改开始时间
      }
      this.queryDataQuery.limit = Object.assign({}, this.queryDataQuery.limit, data)

      this.init()
    },
    /**
     * @description: 查询
     * @event:
     * @param {*}
     * @return {*}
     */
    queryHandel() {
      this.queryDataQuery.limit.current = 10
      this.queryDataQuery.limit.current = 1
      
      if (Array.isArray(this.queryDataQuery.limit.time) &&  this.queryDataQuery.limit.time.length > 1) {
        //  updateEndTime: '', //修改结束时间
        //   updateStartTime: '', //修改开始时间
        this.queryDataQuery.limit.updateEndTime =  this.$machiningTime(this.queryDataQuery.limit.time[1])
        this.queryDataQuery.limit.updateStartTime = this.queryDataQuery.limit.time[0]
      } else {
        this.queryDataQuery.limit.updateEndTime = ''
        this.queryDataQuery.limit.updateStartTime = ''
      }

      this.init()
    },
    /**
     * @description: 分页
     * @event:
     * @param {*}
     * @return {*}
     */
    getList(e) {
      this.init()
    },
    /**
     * @description:查看详情功能
     * @event:
     * @param {*}
     * @return {*}
     */
    hometHandel() {
      this.$message.success('功能开发中')
    },
    /**
     * @description: 加工时间
     * @event:
     * @param {*}
     * @return {*}
     */
    machiningHandel() {},
    //获取医院信息接口
    async init() {
      let paramData = JSON.parse(JSON.stringify(this.queryDataQuery));
      paramData.limit.disabled = this.tabList.find(
        (item) => item.label == this.queryDataQuery.limit.disabled
      ).name;
      let res = await api_hospital(paramData.limit)
      this.all = res.data.records
      this.queryDataQuery.total = res.data.total
    },
  },
  mounted() {
    this.init()
    this.getcodechildrenList()
    this.regionAll()
  },
}
</script>

<style lang="less" scoped>
.footer{
  display: flex;
  justify-content: space-around;
  p{
      display: flex;
      span{
          display: block;
          margin-left: 20px;
      }
  }
}
.slot-footer{
  display: flex;
  justify-content: center;
  position: relative;
  padding-bottom: 24px;
  .btn{
      position: absolute;
      right: 0;
      top: 0;
  }
}
.view-name {
  height: 46px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.el-scrollbar__wrap {
  overflow-x: hidden !important;
}
.organization {
  // width: 100%;
  // height: 100%;
  .organization-top {
    background-color: #fff;
    height: 90px;
    width: 100%;
    border-radius: 15px;
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    padding: 0px 15px;
    .organization-top-person {
      font-weight: bolder;
      margin-right: 15px;
      flex: 1;
      line-height: 90px;
    }
    .organization-top-search {
      width: 250px;
      line-height: 90px;
      /deep/.el-input__inner {
        border-radius: 20px;
      }
    }
    .organization-top-btn {
      margin-left: 35px;
      margin-top: 25px;
      /deep/.el-dropdown {
        margin-left: 20px;
        .el-button {
          border-radius: 20px;
        }
      }
    }
    .organization-top-date {
      margin-left: 35px;
      line-height: 90px;
      .el-date-editor {
        border-radius: 20px;
        border-color: skyblue;
      }
    }
  }
  .organization-content {
    // height: 700px;
    width: 100%;
    background-color: #fff;
    border-radius: 15px;
    // margin-top: 30px;
    box-sizing: border-box;
    // padding: 10px 20px;
    & /deep/.el-table th > .cell {
      text-align: center;
    }
    & /deep/.el-table .cell {
      text-align: center;
    }
    .operation {
      display: flex;
      flex-wrap: nowrap;
      .el-button {
        border: none;
        color: skyblue;
        background: #fff;
        padding: 0;
      }
    }
    .cardpage {
      margin-top: 40px;
      text-align: right;
    }
  }
  .organization-right {
    & /deep/.el-drawer__header {
      font-size: 18px;
      font-weight: bolder;
      color: skyblue;
    }
  }
}
</style>
